import React from 'react'
import { Button } from 'antd'
import { PlusOutlined } from '@ant-design/icons';

export const NoBlogPosts = ({ onNewBlogPost }: { onNewBlogPost: () => void }) => {
  return (
    <div className="flex flex-col items-center justify-center" style={{ height: '60vh' }}>
      <div className="text-center">
        <h3 className="text-20 mb-10" style={{ color: '#000000', fontWeight: '600', fontSize: '20px' }}>
          Looks like you haven't created any <br /> blog posts yet
        </h3>
        <p className="text-16 mb-10" style={{ color: '#000000', fontWeight: '400', fontSize: '14px' }}>Once you added your first blog post it will appear here.</p>
        <Button 
          type="primary" 
          className="br-8"
          style={{lineHeight: '20px', fontWeight:'500', fontSize:'15px',width: '183px', height: '37px' }}
          onClick={onNewBlogPost}
        >
          <PlusOutlined />
          New blog post
        </Button>
      </div>
    </div>
  )
}

export default NoBlogPosts
